import React from "react";
import { Route, Routes, HashRouter } from "react-router-dom";
import Home from "pages/home/HomeComponent";
import Splash from "pages/splash/Splash";
import Education from "pages/education/EducationComponent";
import Experience from "pages/experience/Experience";
import Contact from "pages/contact/ContactComponent";
import Projects from "pages/projects/Projects";
import ThemeColorPicker from "components/themeColorPicker";
import ScrollToTop from "components/scrollToTop/ScrollToTop";
import { ScrollProgress } from "components/scrollProgress/ScrollProgress";
import { CursorGlow } from "components/cursorGlow/CursorGlow";
import { settings } from "portfolio";
import type { Theme } from "types";

interface MainProps {
  theme: Theme;
  setTheme: React.Dispatch<React.SetStateAction<string>>;
  onColorChange: (accentColor: string, accentBright: string) => void;
  isColorPickerOpen?: boolean;
  onColorPickerOpenChange?: (isOpen: boolean) => void;
}

export default function Main({
  theme,
  setTheme,
  onColorChange,
  isColorPickerOpen = false,
  onColorPickerOpenChange,
}: Readonly<MainProps>): React.ReactElement {
  const splashElement = <Splash theme={theme} setTheme={setTheme} />;
  const homeElement = <Home theme={theme} setTheme={setTheme} />;

  return (
    <div className="dot-grid noise-overlay">
      <ScrollProgress />
      <CursorGlow />
      <HashRouter basename="/">
        <ScrollToTop>
          <Routes>
            <Route
              path="/"
              element={settings.isSplash ? splashElement : homeElement}
            />
            <Route path="/home" element={homeElement} />
            <Route
              path="/experience"
              element={<Experience theme={theme} setTheme={setTheme} />}
            />
            <Route
              path="/education"
              element={<Education theme={theme} setTheme={setTheme} />}
            />
            <Route
              path="/contact"
              element={<Contact theme={theme} setTheme={setTheme} />}
            />
            <Route
              path="/projects"
              element={<Projects theme={theme} setTheme={setTheme} />}
            />
            {settings.isSplash && (
              <Route path="/splash" element={splashElement} />
            )}
          </Routes>
        </ScrollToTop>
      </HashRouter>
      <ThemeColorPicker
        currentTheme={theme}
        onColorChange={onColorChange}
        isOpen={isColorPickerOpen}
        onOpenChange={onColorPickerOpenChange}
        showFloatingButton={false}
      />
    </div>
  );
}
